import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { StyleSheetManager, ThemeProvider } from 'styled-components';
import { defaultTheme, shouldForwardProp } from '@web-chat-core/ui-kit';
import { SettingsProvider, UserSettingsProvider } from 'contexts';
import { AppRoot } from 'pages/AppRoot';
import GlobalStyle from 'ui/globalStyle';
import { MeetSnackbar } from 'ui/components/MeetSnackbar/view';
import { AppEnvironmentProvider } from 'contexts/AppEnvironmentContext';
import { resetSessionStorageForMeetBoot } from 'features/PreJoin/utils/waitingRoom/session';
import '@web-chat-core/ui-kit/assets/style.css';

export const App = () => {
    return (
        <AppEnvironmentProvider value={{}}>
            <SettingsProvider>
                <UserSettingsProvider>
                    <StyleSheetManager enableVendorPrefixes shouldForwardProp={shouldForwardProp}>
                        <GlobalStyle theme={defaultTheme} />
                        <ThemeProvider theme={defaultTheme}>
                            <BrowserRouter>
                                <MeetSnackbar>
                                    <AppRoot />
                                </MeetSnackbar>
                            </BrowserRouter>
                        </ThemeProvider>
                    </StyleSheetManager>
                </UserSettingsProvider>
            </SettingsProvider>
        </AppEnvironmentProvider>
    );
};

resetSessionStorageForMeetBoot();

const container = document.getElementById('root');
const root = createRoot(container as HTMLElement);

root.render(<App />);

console.log('process.env.REACT_APP_VERSION', process.env.REACT_APP_VERSION);
